module.exports = __webpack_public_path__ + "img/title.9db8add1.png";